import React, { useContext, useEffect } from 'react'
import store from './store'
import addStore from './helper/addStore'
import widgetService from 'live/services/widgets'
import ConfigWidget from './config'

//@ts-nocheck
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { DashboardContext } from 'live/context/dashboard'
import { reducer } from './reducer'
import { MainPropState } from './helper/reducer/getInitialState'
import App from './init'
export interface Event {
    [key: string]: any
}

export enum TypesFields {
    array = 'java.lang.Iterable',
    boolean = 'java.lang.Boolean',
    map = 'java.util.Map',
    number = 'java.lang.Double',
    object = 'java.lang.Object',
    string = 'java.lang.String'
}
export interface DispathEvent {
    type: string
    [key: string]: any
}

interface EventStart {
    fields: {
        [key: string]: TypesFields
    }
    group: string[]
    select: string[]
}

interface Props {
    event: Event
    widget: {
        id: string | number
    }
    width: number
    height: number
    batch: Event[]
    options: {
        cfg: {}
    }
    state: MainPropState
    dispatch(param: DispathEvent)
}

const Widget = (props: Props) => {
    const { widget = {}, dispatch, state } = props

    const context = useContext(DashboardContext)

    if (!context?.dashboard) {
        useEffect(() => {
            const layers = Object.entries(state.info.select).reduce((state, [layer, info]) => {
                return {
                    ...state,
                    [layer]: {
                        name: `Layer ${layer + 1}`,
                        columns: info,
                        rows: info,
                        values: info,
                        showTotal: widget?.jsonConfig.layers?.showTotal || false
                    }
                }
            }, {})

            dispatch({ type: 'layers', layers })
        }, [state?.info])
    }

    return <App config={widget?.jsonConfig} mainInfo={state} />
}
interface Layers {
    [id: number]: Layer
}

interface Layer {
    name: string
    columns: string[]
    rows: string[]
    values: string[]
    showTotal: boolean
}

export { Layers, Layer }

widgetService.register({
    type: 'pivotal-table',
    get name() {
        return 'pivotal-table'
    },
    get description() {
        return 'pivotal-table'
    },
    ui: {
        configForm: addStore({ store })(ConfigWidget)
    },
    config: {
        showModal: false,
        showTabs: true,
        showTotal: true,
        columns: [],
        rows: [],
        layers: {
            0: {
                name: 'Layer 1',
                columns: [],
                rows: [],
                values: [],
                showTotal: false
            }
        }
    },
    policies: {},

    impl: reactWidgetWrapper(addStore({ store })(React.memo(Widget)), reducer)
})
